import { render, staticRenderFns } from "./TrTooltip.vue?vue&type=template&id=39a3b5f4&scoped=true"
import script from "./TrTooltip.vue?vue&type=script&lang=ts"
export * from "./TrTooltip.vue?vue&type=script&lang=ts"
import style0 from "./TrTooltip.vue?vue&type=style&index=0&id=39a3b5f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3b5f4",
  null
  
)

export default component.exports